import { Text } from "@certn/cascadia";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

interface ApplicantSuppliedDetailsPanelProps {
  details?: Record<string, string | null>;
}

export function ApplicantSuppliedDetailsPanel({
  details,
}: ApplicantSuppliedDetailsPanelProps) {
  const { t } = useTranslation();

  const displayValue = (value: string | null | undefined) =>
    value?.trim() ? value : t("—");

  return (
    <div
      className={styles.suppliedDetailsPanel}
      data-testid="applicant-supplied-details"
    >
      <Text style="global/heading-small">
        {t("Applicant supplied details")}
      </Text>
      <div className={styles.suppliedDetailsRow}>
        <SuppliedDetailColumn
          label={t("Name")}
          value={displayValue(details?.name)}
        />
        <SuppliedDetailColumn
          label={t("Previous names")}
          value={displayValue(details?.previous_names)}
        />
        <SuppliedDetailColumn
          label={t("Date of birth")}
          value={displayValue(details?.date_of_birth)}
        />
      </div>
    </div>
  );
}

function SuppliedDetailColumn({
  label,
  value,
}: {
  label: string;
  value: string;
}) {
  return (
    <div className={styles.suppliedDetailColumn}>
      <Text style="input/label" color="text-weak">
        {label}
      </Text>
      <Text style="global/body-secondary">{value}</Text>
    </div>
  );
}

const styles = {
  suppliedDetailsPanel: css({
    backgroundColor: "var(--color-surface-secondary, #f5f5f5)",
    borderRadius: "var(--border-radius-2, 8px)",
    padding: "var(--space-4)",
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
  }),
  suppliedDetailsRow: css({
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: "var(--space-4)",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr",
    },
  }),
  suppliedDetailColumn: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
  }),
};
